<template>
    <div>
        <div class="gameView">
            <div class="playerSettings" v-for="(player, index) in players" :class="{active: player.active}">
                <player-settings v-if="players[index+1] !== undefined" :player="player" :next-player="players[index+1]">
                    <span @click="removePlayer(index)" class="button button--small"><font-awesome-icon icon="trash"></font-awesome-icon></span>
                </player-settings>
                <player-settings v-else :player="player" :next-player="players[0]">
                    <span @click="removePlayer(index)" class="button button--small"><font-awesome-icon icon="trash"></font-awesome-icon></span>
                </player-settings>
            </div>
        </div>
        <div class="gameSettings">
            <span v-if="this.$store.state.game === 'playing'" class="button" @click="undoLastTurn"><font-awesome-icon icon="undo"></font-awesome-icon></span>
            <div v-else-if="this.$store.state.game === 'starting'">
                <br />
                <input type="number" min="1" @change="changeBaseScore" v-model="baseScore"><br />
                <span class="checkbox"  @click="changePreciselyZero" >
                    <font-awesome-icon v-if="preciselyZero" icon="check"></font-awesome-icon>
                    <font-awesome-icon v-else icon="times"></font-awesome-icon>
                    Spel eindigt precies op nul
                </span><br />
                <span class="button" @click="addPlayer"><font-awesome-icon icon="user-plus"></font-awesome-icon></span>
                <span class="button" @click="start">start</span>
            </div>
            <div v-else-if="this.$store.state.game === 'completed'">
                <a class="button" href="/">Nieuw spel</a>
            </div>
        </div>
    </div>
</template>

<script>
    import Player from '../Classes/Player';
    import PlayerSettings from "../components/PlayerSettings";

    export default {
        name: "GamePage",
        data() {
            return{
                players: [

                ],
                baseScore: this.$store.state.baseScore,
                preciselyZero: this.$store.state.settings.mustEndOnExactlyZero
            }
        },
        created() {
            let playerNames = window.localStorage.getItem('playerNames');
            if(!playerNames){
                playerNames = '["Speler 1","Speler 2"]';
            }

            let playersArray = JSON.parse(playerNames);
            playersArray.forEach(name => this.players.push(new Player(name)));

            EventBus.$on('sort-players', this.sortPlayers);
        },
        methods: {
            addPlayer() {
                this.players.push(new Player('Naam'));
            },
            start(){
                let playerNames = [];
                this.players.forEach(player => playerNames.push(player.name));
                window.localStorage.setItem('playerNames', JSON.stringify(playerNames));

                this.players[0].active = true;
                this.$store.state.game = 'playing';
            },
            changeBaseScore(){
                this.$store.state.baseScore = parseInt(this.baseScore);
            },
            changePreciselyZero(){
                this.preciselyZero = !this.preciselyZero;
                this.$store.state.settings.mustEndOnExactlyZero = this.preciselyZero;
            },
            removePlayer(index){
                this.players.splice(index, 1);
            },
            sortPlayers(){
                this.players.sort(this.sortPlayersByScore)
            },
            undoLastTurn(){
                for(let i = 0; i < this.players.length; i++){
                    if(!this.players[i].active){
                        continue;
                    }
                    let j = i - 1;
                    if(j < 0){
                        j = this.players.length - 1;
                    }

                    if(this.players[j].thrown.length > 1){
                        this.players[i].active = false;
                        this.players[j].active = true;
                        this.players[j].undoLastTurn();
                    }
                    break;
                }
            },
            sortPlayersByScore(player1, player2){
                return player1.getCurrentScore(this.$store.state.baseScore) - player2.getCurrentScore(this.$store.state.baseScore)
            }
        },
        components: {
            PlayerSettings,
        }
    }
</script>

<style scoped>

</style>